import Icon, { ICON_NAMES } from "shared/components/utils/Icon";
import styled, { createGlobalStyle } from "styled-components";

import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import Text from "shared/components/data-display/text/Text";
import { mediaQueries } from "shared/config/breakpoints";

export const GlobalStyles = createGlobalStyle`
    .notification__item {
        width: max-content;
        
        ${mediaQueries.small} {
            width: calc(100vw - 32px);
            max-width: calc(100vw - 32px);
        }
    }
    .rnc__notification {
        width: max-content !important;
        min-width:max-content;
        
        ${mediaQueries.small} {
            width: calc(100vw - 32px) !important;
            max-width: calc(100vw - 32px) !important;
            min-width: auto !important;
        }
    }
`;

export const StyledSnackbar = styled(HStack)`
    padding: 10px 16px;
    width: max-content;
    height: 44px;
    background: ${COLOR_VALUES.Gray_1};
    border-radius: 2px;
    
    ${mediaQueries.small} {
        width: 100%;
        max-width: 100%;
        padding: 8px 12px;
        height: auto;
        min-height: 44px;
    }
`;

export const StyledIcon = styled.button`
    border: none;
    background: transparent;
    cursor: pointer;
`;

const StyledTertiaryButton = styled(TertiaryButton)`
    background: ${COLOR_VALUES.Gray_2};
    div{
        color: ${COLOR_VALUES.White};
    }

    &:not(:disabled) {
      &:hover {
            background: ${COLOR_VALUES.Gray_2};
        }
    }
}
`;

const StyledText = styled(Text)`
    ${mediaQueries.small} {
        font-size: 14px;
        line-height: 1.4;
        word-break: break-word;
    }
`;

const Snackbar = ({
    message,
    close,
    action,
    actionProps,
    icon,
    feedbackIcon,
    onClose,
}) => {
    const Message = (
        <HStack spacing="Zero_5" align="center">
            {icon && <Icon name={feedbackIcon} color="White" size={18} />}
            <StyledText variant="Body_2_1" color="White">
                {message}
            </StyledText>
        </HStack>
    );

    return (
        <>
            <GlobalStyles />
            <StyledSnackbar spacing="One">
                {Message}
                {action && <StyledTertiaryButton {...actionProps} />}
                {close && (
                    <StyledIcon
                        type="button"
                        onClick={onClose}
                        aria-label="Close Snackbar"
                    >
                        <Icon name="close" color="White" size={16} />
                    </StyledIcon>
                )}
            </StyledSnackbar>
        </>
    );
};

Snackbar.defaultProps = {
    action: false,
    close: true,
    icon: false,
};

Snackbar.propTypes = {
    message: PropTypes.string,
    action: PropTypes.bool,
    close: PropTypes.bool,
    icon: PropTypes.bool,
    feedbackIcon: PropTypes.oneOf(ICON_NAMES),
    onClose: PropTypes.func,
    actionProps: PropTypes.object,
};

export default Snackbar;
